import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import {
  GetVehicleCardRequest,
  GetVehicleCardResponse
} from "./interfaces/get-vehicle-card";
import { Environment } from "@coxauto-ui/cxm/communications/interfaces";

export async function getVehicleCard(
  data: GetVehicleCardRequest,
  env: Environment
): Promise<GetVehicleCardResponse> {
  const url = `${getBaseUrl(env)}cxm/vehicle-card`;
  const header = await getHeader();
  const queryParams = new URLSearchParams({
    dealerId: data.dealerId.toString(),
    consumerId: data.consumerId,
    autoLeadId: data.autoLeadId.toString(),
    cardType: data.cardType
  });

  if (data.consumerRecordSystem) {
    queryParams.append("consumerRecordSystem", data.consumerRecordSystem);
  }

  try {
    const response = await fetchWrapper.getAsync<GetVehicleCardResponse>(
      `${url}?${queryParams.toString()}`,
      header
    );

    if (response && response.data && !response.hasError) {
      return response.data;
    } else {
      // eslint-disable-next-line no-console
      console.error(
        `Error fetching vehicle card for cardType: ${data.cardType}`,
        response?.error
      );
      return {
        errorType: response?.statusCode === 404 ? "not_found" : "generic"
      };
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      `Exception fetching vehicle card for cardType: ${data.cardType}`,
      error
    );
    return { errorType: "generic" };
  }
}
